




















import {Component, Vue} from 'vue-property-decorator';
import {ESettori} from "@/types";

@Component({
    name: "Help"
})
export default class Help extends Vue {
    private settori = [{codice: ESettori.Ortofrutta, etichetta: "Ortofrutta"},
        {codice: ESettori.Florovivaismo, etichetta: "Florovivaismo"},
        {codice: ESettori.ViteOlivo, etichetta: "Vite & Olivo"},
        {codice: ESettori.Allevamento, etichetta: "Allevamento"},];
    esettori = ESettori;
}

